<template>
  <v-card-text style="color: #4F4F4F">
    <v-row class="pa-3">
      Your user account for HawkSoft E-Signature has been activated. You are almost done.
    </v-row>
    <ol class="pb-3">
      <li style="text-align: start">Check your email again, Formstack Sign will send you a link to set up a password.</li>
      <li style="text-align: start">Once a password is set up, restart HawkSoft CMS and begin sending documents for electronic signature.</li>
    </ol>
  </v-card-text>
</template>

<script>
export default {
  name: 'Activate'
};
</script>
